// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-item-label{color:white;font-size:12px;line-height:16px;white-space:nowrap}\n", ""]);
// Exports
module.exports = exports;
